/* eslint-disable import/order */
import {
  Avatar,
  Box,
  Grid,
  IconButton,
  InputBase,
  Slide,
  Typography,
  TextField,
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import InputMask from 'react-input-mask'
import axios from 'axios'

import BaseFilterModal from '../../../../components/hooks/BaseFilterModal'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { CustomSwitch } from '../../../../components/ui/custom-switch'
import SelectField from '../../../components/SelectField'
import colors from '../../../../assets/colors'
import { KeyboardDateTimePicker } from '@material-ui/pickers'
import { mdiAccountPlus } from '@mdi/js'
import Icon from '@mdi/react'
import filterStylesComponents from '../../../../assets/filterComponentsStyles'
import { SNACKBAR } from '../../../main/MainActions'
import { addMinutes, format } from 'date-fns'
import { newAppointment } from '../AppointmentsActions'

export const NewAppointment = props => {
  const dispatch = useDispatch()
  const history = useHistory()

  const laundries = useSelector(state => state.appointments.laundries)
  const streetAttendants = useSelector(
    state => state.appointments.streetAttendants
  )

  const styles = filterStylesComponents()

  const [form, setForm] = useState({
    laundry_id: null,
    attendant_id: null,
    attendant: {},
    laundry: {},
    delivery: false,
    date_time: addMinutes(new Date(), 10),
    // Campos de endereço
    name: '',
    cep: '',
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    uf: '',
    observation: '',
  })

  const [addressErrors, setAddressErrors] = useState({})

  const onClose = () => {
    history.goBack()
  }

  const validatorToast = (message = '') => {
    return dispatch({
      type: SNACKBAR.HARDFAIL,
      error: {
        message,
      },
    })
  }

  const validateAddress = () => {
    const errors = {}

    if (form.delivery) {
      if (!form.cep) errors.cep = 'CEP é obrigatório'
      if (!form.street) errors.street = 'Rua é obrigatória'
      if (!form.number) errors.number = 'Número é obrigatório'
      if (!form.neighborhood) errors.neighborhood = 'Bairro é obrigatório'
      if (!form.city) errors.city = 'Cidade é obrigatória'
      if (!form.uf) errors.uf = 'UF é obrigatório'
    }

    setAddressErrors(errors)
    return Object.keys(errors).length === 0
  }

  const handleCepBlur = async e => {
    const currentCep = e.target.value.replace(/\D/g, '')

    try {
      if (currentCep?.length === 8) {
        const response = await axios.get(
          `https://viacep.com.br/ws/${currentCep}/json/`
        )
        const data = response.data

        if (!data.erro) {
          setForm(prev => ({
            ...prev,
            street: data.logradouro || '',
            neighborhood: data.bairro || '',
            city: data.localidade || '',
            uf: data.uf || '',
          }))
        }
      }
    } catch (error) {
      // console.log(error)
    }
  }

  const handleInputChange = (field, value) => {
    setForm(prev => ({
      ...prev,
      [field]: value,
    }))

    if (addressErrors[field]) {
      setAddressErrors(prev => ({
        ...prev,
        [field]: '',
      }))
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()

    if (!form?.laundry_id) {
      return validatorToast('Selecione a lavanderia!')
    }

    if (!form?.attendant_id) {
      return validatorToast('Selecione o atendente!')
    }

    if (!validateAddress()) {
      return validatorToast(
        'Preencha todos os campos obrigatórios do endereço!'
      )
    }

    const data = {
      ...form,
      date_time: format(form?.date_time, 'yyyy-MM-dd HH:mm:ss'),
    }

    const resp = await dispatch(newAppointment(data, form.laundry_id))

    if (resp?.code) onClose()
  }

  return (
    <BaseFilterModal
      open
      handleOpen={onClose}
      title="Novo Agendamento Avulso"
      hiddenHelpButton
    >
      <Grid item xs={12} style={{ width: '600px', marginTop: '.5em' }}>
        <form style={{ width: '100%' }} onSubmit={handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={8} md={6}>
              <SelectField
                options={laundries}
                setForm={(name, laundry) => {
                  setForm({
                    ...form,
                    laundry: laundry,
                    laundry_id: laundry?.id,
                  })
                }}
                data={form?.laundry || null}
                variant="standard"
                required
                name="status"
                label="Selecione a lavanderia"
              />
            </Grid>

            <Grid item xs sm md>
              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="flex-end"
              >
                <Grid item>
                  <Typography
                    style={{ fontWeight: 'bold', textTransform: 'capitalize' }}
                  >
                    Delivery
                  </Typography>
                </Grid>
                <Grid item>
                  <CustomSwitch
                    checked={form?.delivery}
                    onClick={() =>
                      setForm({ ...form, delivery: !form?.delivery })
                    }
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2} alignItems="flex-end">
                <Grid item xs={2}>
                  <Avatar
                    style={{
                      backgroundColor:
                        form?.attendant?.color || colors?.primary,
                    }}
                  >
                    {form?.attendant?.name
                      ? form?.attendant?.name?.charAt(0)
                      : ''}
                  </Avatar>
                </Grid>
                <Grid item xs={4}>
                  <SelectField
                    options={streetAttendants}
                    setForm={(name, attendant) => {
                      setForm({
                        ...form,
                        attendant: attendant,
                        attendant_id: attendant?.id,
                      })
                    }}
                    data={form?.attendant || null}
                    label="Técnico"
                    fullWidth
                    required
                    name="attendance"
                    variant="standard"
                  />
                </Grid>
                <Grid item xs={6}>
                  <KeyboardDateTimePicker
                    clearable
                    label="Selecione um dia e horario:"
                    views={['date', 'hours', 'minutes']}
                    clearLabel="Limpar"
                    invalidDateMessage="Data inválida"
                    autoOk
                    disablePast
                    fullWidth
                    value={form?.date_time}
                    onChange={date => {
                      setForm({ ...form, date_time: date })
                    }}
                    required
                    format="dd/MM/yyyy HH:mm"
                  />
                </Grid>
              </Grid>
            </Grid>

            {form.delivery && (
              <>
                <Grid item xs={12}>
                  <Typography variant="h6" style={{ marginTop: '.5em' }}>
                    Endereço do Cliente
                  </Typography>
                </Grid>

                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Nome do Cliente"
                        fullWidth
                        value={form.name}
                        onChange={e =>
                          handleInputChange('name', e.target.value)
                        }
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <InputMask
                        mask="99.999-999"
                        formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
                        maskChar=""
                        value={form.cep}
                        onChange={e => handleInputChange('cep', e.target.value)}
                        onBlur={handleCepBlur}
                      >
                        {() => (
                          <TextField
                            label="CEP"
                            fullWidth
                            error={!!addressErrors.cep}
                            helperText={addressErrors.cep}
                          />
                        )}
                      </InputMask>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={8}>
                      <TextField
                        label="Rua"
                        fullWidth
                        value={form.street}
                        onChange={e =>
                          handleInputChange('street', e.target.value)
                        }
                        error={!!addressErrors.street}
                        helperText={addressErrors.street}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        label="Número"
                        fullWidth
                        value={form.number}
                        onChange={e =>
                          handleInputChange('number', e.target.value)
                        }
                        error={!!addressErrors.number}
                        helperText={addressErrors.number}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={4}>
                      <TextField
                        label="Bairro"
                        fullWidth
                        value={form.neighborhood}
                        onChange={e =>
                          handleInputChange('neighborhood', e.target.value)
                        }
                        error={!!addressErrors.neighborhood}
                        helperText={addressErrors.neighborhood}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField
                        label="Cidade"
                        fullWidth
                        value={form.city}
                        onChange={e =>
                          handleInputChange('city', e.target.value)
                        }
                        error={!!addressErrors.city}
                        helperText={addressErrors.city}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="UF"
                        fullWidth
                        value={form.uf}
                        onChange={e => handleInputChange('uf', e.target.value)}
                        error={!!addressErrors.uf}
                        helperText={addressErrors.uf}
                      />
                    </Grid>
                    <Grid item xs={2}>
                      <TextField
                        label="Complemento"
                        fullWidth
                        value={form.complement}
                        onChange={e =>
                          handleInputChange('complement', e.target.value)
                        }
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Typography style={{ color: colors.textGray }}>
                        Observação
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <InputBase
                        value={form.observation}
                        onChange={e =>
                          handleInputChange('observation', e.target.value)
                        }
                        multiline
                        inputProps={{
                          style: {
                            minHeight: '72px',
                            height: '95%',
                          },
                        }}
                        fullWidth
                        style={{
                          borderRadius: '15px',
                          border: `1px solid ${colors.graylight}`,
                          color: colors.textGray,
                          padding: '8px',
                          minHeight: '95px',
                          height: '100%',
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}

            <Grid item xs={12} style={{ marginTop: '1em' }}>
              <Grid
                container
                spacing={2}
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item>
                  <IconButton
                    type="button"
                    onClick={onClose}
                    className={styles.btnMoreFilters}
                  >
                    Fechar
                  </IconButton>
                </Grid>
                <Grid item>
                  <IconButton type="submit" className={styles.btnSalvar}>
                    <Icon
                      path={mdiAccountPlus}
                      size={1}
                      style={{ marginRight: '4px' }}
                    />
                    Adicionar
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </BaseFilterModal>
  )
}
